import moment from 'moment-timezone'

export const CYCLE_COUNT_TZ = 'America/Chicago'

const hasZoneInfo = (s) => /([zZ]|[+-]\d\d:\d\d)$/.test(String(s).trim())

/**
 * Parse physcntdate:
 * - If payload includes Z or an offset => preserve that exact instant (parseZone).
 * - If payload is naive => interpret it in CYCLE_COUNT_TZ.
 */
export const parsePhyscntDate = (s) =>
  hasZoneInfo(s) ? moment.parseZone(s) : moment.tz(String(s), CYCLE_COUNT_TZ)

export const startOfCycleCountDay = (m) =>
  m.clone().tz(CYCLE_COUNT_TZ).startOf('day')

export const formatPhyscntDateLL = (s) =>
  s ? parsePhyscntDate(s).tz(CYCLE_COUNT_TZ).format('LL') : 'N/A'

export const daysSincePhyscntDate = (s, now = moment()) =>
  startOfCycleCountDay(now).diff(
    startOfCycleCountDay(parsePhyscntDate(s)),
    'days',
  )
